import { createSelector } from 'reselect'

export const getMaxRevenue = createSelector(
  state => state.search.selectedStores,
  state => state.search.showSelectedOnly,
  (selectedStores, showSelectedOnly) => {
    if (!showSelectedOnly) {
      return 0
    }

    return Math.max(...selectedStores.map(selectedStore => selectedStore.revenueCurrent))
  },
)
